angular.module('unergie.main')
.directive('userInfoContractActions', ($filter, $window, BoFeaturesService, ModalService, DataAccess, DataAccessSearch, AlertManager, ApiUser, AdminComments, PaymentService,
    MetaWatcher, AmountService, ReferencesService, ErrorCatcher, ApiAdmin, ApiBilling, TogglerUtils, ApiContent, EnvUtils, AuthService) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractActions.html',
        link($scope) {
            $scope.canImportLandscapeProd = AuthService.userHasGroup(['data-admin']) && $scope.contract.status === 80
            const accountinfoFeats = BoFeaturesService.getModuleFeatures('accountinfo')
            const feats = BoFeaturesService.getModuleFeatures('contracts')

            const canActivateBeforeSubFee = BoFeaturesService.isFeatureOn('canActivateBeforeSubFee')
            $scope.trainingMode = BoFeaturesService.isFeatureOn('trainingMode')
            $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
            $scope.adminPaymentMode = BoFeaturesService.isFeatureOn('adminPaymentMode')
            $scope.togglerUtils = TogglerUtils
            $scope.canByPassDeposit = BoFeaturesService.isFeatureOn('canByPassDeposit')
            $scope.canByPassRedFlagDepositWithoutComment = BoFeaturesService.isFeatureOn('canByPassRedFlagDepositWithoutComment')
            $scope.modifOtPsWithOverdue = BoFeaturesService.isFeatureOn('modifOtPsWithOverdue')
            $scope.canByPassBalanceCheck = BoFeaturesService.isFeatureOn('canByPassBalanceCheck')

            $scope.isElec = $scope.contract.energy_type === 'ELEC'
            $scope.isRedFlag = $scope.contract.isRedFlag

            $scope.showOverduePaymentRegularization = !$scope.adminPaymentMode && (
                ['SUSPENDED', 'SUSPENSION_REQUESTED', 'LIMITED', 'LIMITATION_REQUESTED'].includes($scope.contract.suspension_status) ||
                [14].includes($scope.contract.status))

            $scope.isAIFeatureOn = (feature) => accountinfoFeats[feature]

            $scope.canReducOutage = () => feats.canReducOutage
            $scope.shouldOpenPopupConfirm = true
            $scope.contractHasChanged = () => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)

            $scope.paymentOnDemand = $scope.account && $scope.account.billingaccount && !$scope.account.billingaccount.hasMandate
                && (!$scope.account.billingaccount.hasCardAlias || moment($scope.account.billingaccount.alias_expiration).isBefore(moment()))

            $scope.overdueCheck = function () {
                if (!$scope.contract.overdue_check) {
                    return 'ok'
                }
                if ($scope.contract.depositBalance) {
                    if ($scope.contract.depositDate) {
                        return 'deposit'
                    }
                    return 'waiting_deposit'
                }
                return 'ko'
            }

            // DEPOSIT DURATION
            const initDepositDuration = (depositDate) => {
                $scope.depositDuration = 0
            }

            $scope.$watch('contract.depositDate', initDepositDuration)

            $scope.isPreActive = () => {
                return [0, 1, 9, 80, 81, 82, 83, 84, 90, 91, 92, -1].includes($scope.contract.status)
            }

            $scope.canChangeOtPs = () => {
                return $scope.contract.status === 2 &&
                    ($scope.modifOtPsWithOverdue || [null, undefined, 'CANCELLED'].includes($scope.contract.suspension_status))
            }

            // CONTRACT MANAGEMENT
            $scope.canActivate = function () {
                $scope.activateButton = 'Activer'
                $scope.activateTitle = 'Activer'
                let blockForSubscriptionFees = false
                const isBlockedForOverdue = !$scope.canByPassBalanceCheck && $scope.account.balances && $scope.account.balances.blocked !== false
                const isActivatableStatus = ([0, 9, 81, 82, 83, 92].indexOf($scope.contract.status) > -1)
                const isAfterRetractionPeriod = moment($scope.contract.retraction_end_date).isBefore(moment())
                if (isBlockedForOverdue) {
                    const contracts = _.map($scope.account.balances && $scope.account.balances.overdueContracts, (value, key) => `${key}: ${value} €`)
                    $scope.activateTitle = contracts.length === 1 ? `Un contrat présente un solde débiteur : ${contracts[0]}`
                        : `Plusieurs contrats présentent des soldes débiteurs : ${contracts.join(', ')}`
                }
                if (!isAfterRetractionPeriod) {
                    $scope.activateTitle = 'Le contrat est toujours en période de rétractation'
                }
                if (!isActivatableStatus) {
                    $scope.activateTitle = `Le contrat n'est pas dans un statut activable`
                }
                if ($scope.contract.bulk_purchase && $scope.contract.subscription_fee &&
                    ($scope.contract.contractBalance.balance < 0 || $scope.contract.contractBalance.paid < $scope.contract.subscription_fee)) {
                    if (!canActivateBeforeSubFee) {
                        blockForSubscriptionFees = true
                    }
                    $scope.activateButton = `Attente Frais ${$scope.contract.bulk_purchase.toUpperCase()}`
                    $scope.activateTitle = `Le contrat est issu d'un achat groupé, et les frais de ${$scope.contract.subscription_fee} € n'ont pas encore été réglés.`
                }
                const overdueStatus = $scope.overdueCheck()
                if (overdueStatus === 'waiting_deposit') {
                    $scope.activateButton = 'DG en validation'
                    $scope.activateTitle = `Le dépôt de garantie a été fait, mais il est en attente de validation (${$filter('duration')($scope.depositDuration)})`
                }
                if (overdueStatus === 'ko') {
                    if ($scope.isRedFlag) {
                        $scope.activateTitle = `L'activation du contrat sera lancée une fois le dépôt de garantie payé par le client`
                    } else {
                        $scope.activateTitle = `Un dépôt de garantie a été demandé au client. Contactez le niveau 2 si vous pensez qu'il est pertinent de le supprimer.`
                    }
                }
                return isActivatableStatus &&
                    isAfterRetractionPeriod &&
                    ['ok', 'deposit'].includes(overdueStatus) &&
                    $scope.depositDuration <= 0 &&
                    !blockForSubscriptionFees &&
                    !isBlockedForOverdue
            }

            $scope.canRetract = function () {
                const isRetractableContract = ([0, 80, 81, 82, 83].indexOf($scope.contract.status) > -1)
                const isInRetractionPeriod = moment($scope.contract.retraction_end_date).isAfter(moment())
                return isRetractableContract && isInRetractionPeriod
            }

            $scope.canOverdueCheck = function () {
                const isPossibleOverdueContract = ([0, 9, 80, 81, 82, 83, 84].indexOf($scope.contract.status) > -1)
                return feats.overdueCheck && $scope.contract.overdue_check && isPossibleOverdueContract && !['ok', 'deposit', 'waiting_deposit'].includes($scope.overdueCheck())
            }

            $scope.canCancel = function () {
                const isCancellableContract = ([0, 9, 80, 81, 82, 83, 84, 92].indexOf($scope.contract.status) > -1)
                return feats.canCancelContract && isCancellableContract && !['deposit', 'waiting_deposit'].includes($scope.overdueCheck())
            }

            $scope.canDeposit = () => ([-1, 0, 10, 9, 92, 80, 81, 82, 83].indexOf($scope.contract.status) > -1) && $scope.isFeatureOn('securityDeposit')

            $scope.canTerminate = () => [2, 5, 15].indexOf($scope.contract.status) > -1 && BoFeaturesService.isFeatureOn('canTerminate')

            const refreshPrmBeforeOpeningModal = () => {
                if (moment($scope.contract.prm.modification_ts).isAfter(moment().startOf('day'))) {
                    return Promise.resolve()
                }
                $scope.refreshingPrm = true
                AlertManager.success(`Le données du PDL ne sont plus tout à fait à jour, rafraîchissement auprès d'Enedis en cours, la fenêtre s'ouvrira une fois l'opération terminée.`, 3000)
                return ApiUser.refreshPrm({ idContract: $scope.contract.id, idPrm: $scope.contract.id_prm, strict: false }, { prm: 'all' }).$promise
                .then((updated) => {
                    return DataAccess.getPrmById({ id_prm: $scope.contract.id_prm }).$promise.then((refreshedPrm) => {
                        _.assign($scope.contract.prm, refreshedPrm)
                        const comment = `<b>AUTOMATIQUE</b> : PRM rafraichi avant ouverture du changement d'option tarifaire/puissance souscrite`
                        AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                        MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    })
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.refreshingPrm = false
                })
            }

            // CONTRACT MANAGEMENT ACTIONS
            $scope.openModifOtPsModal = () => ModalService.openModal({ type: 'modifOtPsModal', size: 'xlg', backdrop: 'static' }, {
                contract: $scope.contract,
                consumptionAnalysis: refreshPrmBeforeOpeningModal().then(() => {
                    return TogglerUtils.isPlum() && ($scope.consumptionAnalysis || $scope.refreshConsumptionAnalysis())
                }),
            })

            $scope.openActivationModal = () => ($scope.isElec ?
                ModalService.openModal({ type: 'contractActivationModal', size: 'xlg', backdrop: 'static' }, { contract: $scope.contract, createJira: true }) :
                AlertManager.error(`Pas encore implémenté !`))


            $scope.retract = () =>
                ApiUser.retractContract({ idAccount: $scope.account.id, idContract: $scope.contract.id }, {}).$promise.then(() => {
                    AlertManager.success('Contract rétracté')
                    const comment = '<b>AUTOMATIQUE</b> : rétractation demandée'
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    return MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract) }).catch(ErrorCatcher)


            $scope.bypassRetract = () =>
                ApiUser.bypassRetract({ idAccount: $scope.account.id, idContract: $scope.contract.id }, {}).$promise.then(() => {
                    AlertManager.success('Délai de rétractation annulé')
                    const comment = '<b>AUTOMATIQUE</b> : renonciation au délai de rétractation'
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    return MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract) }).catch(ErrorCatcher)


            $scope.cancelPayload = {
                email: false,
            }

            $scope.cancelFields = {
                email: {
                    label: 'Envoyer un e-mail au client ?',
                    type: 'radio',
                    required: true,
                    enum: [
                        { label: 'Oui', value: true },
                        { label: 'Non', value: false },
                    ],
                },
            }

            $scope.cancelContract = () =>
                ApiUser.cancelContract({ idAccount: $scope.account.id, idContract: $scope.contract.id, email: $scope.cancelPayload.email }, {}).$promise.then(() => {
                    AlertManager.success('Contract annulé')
                    const comment = '<b>AUTOMATIQUE</b> : contrat annulé'
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    return MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract) }).catch(ErrorCatcher)

            $scope.bypassDepositTemplate = {
                comments: null,
            }

            $scope.bypassDepositFields = {
                comments: {
                    hidden: !$scope.isRedFlag,
                    label: `Veuillez laisser un commentaire dans le cas d'une suppression de DG "rouge"` +
                        `${$scope.canByPassRedFlagDepositWithoutComment ? ' (optionnel)' : ''}`,
                    type: 'text',
                    required: $scope.isRedFlag && !$scope.canByPassRedFlagDepositWithoutComment,
                },
            }

            $scope.validateOverdueCheck = () =>
                ApiUser.validateOverdueCheck({ idAccount: $scope.account.id, idContract: $scope.contract.id }, {})
                .$promise.then(() => {
                    AlertManager.success('Dépot de garantie annulé')
                    const comment = `<b>AUTOMATIQUE</b> : le dépot de garantie "${$scope.isRedFlag ? 'rouge' : 'orange'}" a été supprimé.` +
                        `${$scope.bypassDepositTemplate.comments ? ` <b>Raison</b> : <i>"${$scope.bypassDepositTemplate.comments}"</i>` : ''}`
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    return MetaWatcher.notif('DEPOSIT_CHANGED', $scope.contract) }).catch(ErrorCatcher)


            // OTHER ACTION
            $scope.sendTerminationEmail = () => ($scope.isElec ?
                ApiUser.adminSendTerminationEmail({ id_contract: $scope.contract.id, id_account: $scope.contract.id_account }, {}).$promise.then(() => {
                    AlertManager.success(`Email envoyé à ${$scope.account != null ? $scope.account.mail : undefined}`)
                    const comment = '<b>AUTOMATIQUE</b> : email de résiliation envoyé par email'
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                }).catch(ErrorCatcher) :
                AlertManager.error(`Pas encore implémenté !`))


            $scope.openContractDocumentsModal = () => ModalService.openModal({ type: 'contractDocumentsModal', size: 'md', backdrop: 'static' }, {
                contract: $scope.contract,
                irrecoverabilityCertificates: $scope.account.irrecoverabilityCertificates,
            })

            // GENERATE PAYMENT
            const generatePayment = (paymentPayload) => PaymentService.generatePayment($scope.contract, paymentPayload)

            $scope.newPaymentPayload = PaymentService.newPaymentPayload()
            $scope.newPaymentFields = PaymentService.newPaymentFields()
            $scope.newPaymentButtonLabel = 'Générer'
            $scope.newPaymentConfirm = generatePayment

            $scope.sepaErrorsMapping = {}
            $scope.rejectedSepaPayment = {}

            if (BoFeaturesService.isFeatureOn('showContractPayments')) {
                ReferencesService.getRef('sepa-error-codes', true).then((mapping) => {
                    $scope.sepaErrorsMapping = _.keyBy(mapping, 'id')
                })
            }

            const fetchLastRejectedSepaPayment = () =>
                DataAccessSearch({ orderBy: '-payment_date', limit: 1 })
                .search({ resource: 'payments', id_contract: $scope.contract.id, mode: 'SEPA' }).$promise.then((data) => {
                    $scope.rejectedSepaPayment = _.get(data, '0', {})
                }).catch(ErrorCatcher)


            MetaWatcher.watch('PAYMENT_CHANGED', 'userInfoContractElecActions', $scope, fetchLastRejectedSepaPayment)
            fetchLastRejectedSepaPayment()

            $scope.openStaggerGeneratePaymentModal = (specifyOverdueMode) => {
                return Promise.resolve().then(() => {
                    if ($scope.contract.suspension_status === 'SUSPENSION_REQUESTED' || $scope.contract.suspension_status === 'LIMITATION_REQUESTED') {
                        return ApiUser.refreshSuspensionStatus({ idContract: $scope.contract.id, actualSuspensionStatus: $scope.contract.suspension_status }, {}).$promise.then((result) => {
                            $scope.contract.suspension_status = result.suspension_status || $scope.contract.suspension_status
                        })
                    }
                }).then(() => {
                    const overdueMode = specifyOverdueMode && $scope.contract.status !== 4 && ($scope.contract.status === 14 ? 'TERMINATION_REQUESTED' : $scope.contract.suspension_status)
                    ModalService.openModal(
                        { type: 'staggerGeneratePaymentModal', size: 'md' },
                        {
                            paymentPayload: $scope.newPaymentPayload,
                            overdueMode,
                            noMandate: ($scope.account.billingaccount.revoked || !$scope.account.billingaccount.hasMandate) && !$scope.account.billingaccount.hasCardAlias,
                        },
                        (result) => {
                            return Promise.resolve().then(() => {
                                if (result.cb) {
                                    return PaymentService.sendPaymentMail($scope.contract, result.cb, $scope.contract.contractBalance.balance)
                                }
                                return true
                            }).then((ok) => {
                                if (ok && result.sepa) {
                                    $scope.newPaymentConfirm(result.sepa)
                                }
                            })
                        }
                    )
                })
            }
            $scope.prepareGeneratePayment = function () {
                // Prepare field
                if (['SUSPENDED', 'SUSPENSION_REQUESTED', 'LIMITED', 'LIMITATION_REQUESTED'].indexOf($scope.contract.suspension_status) > -1) {
                    const suspensionStatusMsg = {
                        SUSPENDED:
                            `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `    Le client est coupé` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br>` +
                            `  <span>Pour qu'on demande le rétablissement, le client doit régler son solde en CB</span>` +
                            `</span>`,
                        SUSPENSION_REQUESTED:
                            `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `    Une coupure a été demandée` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br>` +
                            `  <span>Pour l'annuler, le client doit régler son solde en CB</span>` +
                            `</span>`,
                        LIMITED:
                            `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `    Le client est limité` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br>` +
                            `  <span>Pour qu'on demande le rétablissement, le client doit régler son solde en CB</span>` +
                            `</span>`,
                        LIMITATION_REQUESTED:
                            `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `    Une limitation a été demandée` +
                            `    <i class="fa fa-ban" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br>` +
                            `  <span>Pour l'annuler, le client doit régler son solde en CB</span>` +
                            `</span>`,
                    }
                    $scope.newPaymentButtonLabel = 'Générer'
                    $scope.newPaymentConfirm = generatePayment
                    $scope.newPaymentFields = _.assign(
                        {},
                        {
                            info: {
                                type: 'label',
                                label: suspensionStatusMsg[$scope.contract.suspension_status],
                            },
                        },
                        PaymentService.newPaymentFields()
                    )
                    $scope.shouldOpenPopupConfirm = false
                } else if ($scope.account.billingaccount.revoked) {
                    const rejectionInfo = _.get($scope.sepaErrorsMapping, $scope.rejectedSepaPayment.rejection_code, {
                        label: `Mandat révoqué - Code d'erreur non défini`,
                        meaning: `La raison de l'erreur n'est pas définie.<br>Il peut s'agir d'une annulation manuelle du paiement.`,
                        possible_actions: 'Selon le cas, contacter le débiteur.',
                    })

                    $scope.newPaymentButtonLabel = 'Fermer'
                    $scope.newPaymentConfirm = _.noop
                    $scope.newPaymentFields = _.assign(
                        {},
                        {
                            info: {
                                type: 'label',
                                label:
                                    `${'<span class="dark-pink">' +
                                    '  <span>'}${rejectionInfo.label}</span>` +
                                    `  <br>` +
                                    `  <br>` +
                                    `  <span>${rejectionInfo.meaning}</span>` +
                                    `  <br>` +
                                    `  <br>` +
                                    `  <span>${rejectionInfo.possible_actions}</span>` +
                                    `</span>`,
                            },
                        }
                    )
                    $scope.shouldOpenPopupConfirm = true
                } else {
                    $scope.newPaymentButtonLabel = 'Générer'
                    $scope.newPaymentConfirm = generatePayment
                    $scope.newPaymentFields = PaymentService.newPaymentFields()
                    $scope.shouldOpenPopupConfirm = false
                }

                // Prepare form payload
                $scope.newPaymentPayload = PaymentService.newPaymentPayload()
                $scope.newPaymentPayload.amount = -$scope.contract.contractBalance.balance
            }

            // REIMBURSE CLIENT
            $scope.reimbursementPayload = PaymentService.newReimbursementPayload()
            $scope.reimbursementFields = PaymentService.reimbursementFields()

            $scope.reimbursementConfirm = () => PaymentService.generateReimbursement($scope.contract, $scope.reimbursementPayload)
            $scope.prepareReimbursement = () => {
                $scope.reimbursementPayload.amount = $scope.contract.contractBalance.balance
            }

            if (BoFeaturesService.isFeatureOn('showContractPayments')) {
                $scope.prepareGeneratePayment()
            }

            // SEND PAYMENT LINK
            $scope.paymentMailPayload = PaymentService.paymentMailPayload()
            $scope.paymentMailFields = PaymentService.paymentMailFields()

            $scope.prepareSendPaymentMail = function () {
                // Prepare field
                $scope.paymentMailFields = PaymentService.paymentMailFields()
                const additionalFields = {}
                const minAmount = $filter('frAmount')(AmountService.decodeFromCents(AmountService.encodeToCents(-$scope.contract.contractBalance.balance) / 2))
                if (['SUSPENSION_REQUESTED', 'LIMITATION_REQUESTED'].includes($scope.contract.suspension_status) || $scope.contract.status === 14) {
                    let action = 'résiliation'
                    if ($scope.contract.status !== 14) {
                        action = $scope.contract.suspension_status === 'SUSPENSION_REQUESTED' ? 'coupure' : 'limitation'
                    }
                    additionalFields.info = {
                        type: 'label',
                        label: `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>` +
                            `    Une ${action} a été demandée` +
                            `    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br><br>` +
                            `  <span class="book">` +
                            `    Pour l'annuler, demander au client s'il peut régler l'intégralité de sa dette.<br>` +
                            `    Si impossible, il doit payer <b>au minimum 50%</b> en CB (ou ${minAmount}€ minimum). Le paiement du solde restant doit être programmé.` +
                            `    <br>` +
                            `    NB: <b>le solde du contrat doit être à 0€</b> pour pouvoir demander l'annulation de la demande de coupure/limitation.` +
                            `  </span>` +
                            `  <br><br>` +
                            `</span>`,
                    }
                } else if (['SUSPENDED', 'LIMITED'].includes($scope.contract.suspension_status)) {
                    additionalFields.info = {
                        type: 'label',
                        label: `<span class="dark-pink">` +
                            `  <span>` +
                            `    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>` +
                            `    Le client est ${$scope.contract.suspension_status === 'SUSPENDED' ? 'coupé' : 'limité'}` +
                            `    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>` +
                            `  </span>` +
                            `  <br><br>` +
                            `  <span class="book">` +
                            `    Pour qu'on demande le rétablissement, le client doit régler 100% de sa dette.<br>` +
                            `    <ul class="dark-pink book"><li>Sur un compteur <b>non communiquant</b>, le client doit être chez lui pour le rétablissement.<br>` +
                            `    Une fois le paiement effectué :` +
                            `    <ul class="dark-pink book"><li>Avant 15h, si le client est disponible le jour même, contacter le niveau 2 en priorité par téléphone</li>` +
                            `    <li>Après 15h, demander au client s'il est disponible le lendemain. ` +
                            `Si oui, faire un ticket au niveau 2. Si non, demander au client de nous rappeler quand il sera disponible.</li></ul></li>` +
                            `    <li>Sur un compteur <b>communiquant</b>: faire un ticket au niveau 2 pour demander le rétablissement.</li></ul>` +
                            `  </span>` +
                            `  <br>` +
                            `</span>`,
                    }
                }
                $scope.paymentMailFields = _.assign(additionalFields, PaymentService.paymentMailFields())

                // Prepare form
                $scope.paymentMailPayload = PaymentService.paymentMailPayload()
                $scope.paymentMailPayload.amount = -$scope.contract.contractBalance.balance
            }

            $scope.sendPaymentMail = () =>
                PaymentService.sendPaymentMail($scope.contract, $scope.paymentMailPayload, $scope.contract.contractBalance.balance)
                .then(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))


            $scope.sleekIt = function () {
                $scope.sleeking = true
                return DataAccess.sleekIt({ id_contract: $scope.contract.id }, {}).$promise.then(() => {
                    return DataAccess.updateSleeking({ id_account: $scope.account.id }, { sleek_timetable: true }).$promise.then(() => {
                        AlertManager.success('Lissage effectué')
                        const comment = '<b>AUTOMATIQUE</b> : lissage effectué'
                        AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                        return MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    })
                }).catch(ErrorCatcher)
                .finally(() => ($scope.sleeking = true))
            }

            $scope.loadEnedisContact = () => ApiUser.getEnedisContact({ id_contract: $scope.contract.id })

            $scope.enedisContactFilter = (elem) =>
                `${`Département: <b>${elem.department}` +
                    '</b><br>Numéro : <b>'}${$filter('phone')(elem.contact)}</b>`


            $scope.openTerminationModal = () => {
                if (!$scope.isElec) {
                    return AlertManager.error(`Pas encore implémenté !`)
                }
                const energy_check_validity_date = _.max(_.map($scope.account.energyChecks, 'validity_date'))
                const energy_check_validity = !!energy_check_validity_date && moment(energy_check_validity_date).add(30, 'days').isAfter(new Date())

                const modalPayload = {
                    contract: $scope.contract,
                    pro: ['pro', 'small-business'].includes($scope.account.category),
                    energy_check_validity,
                    overdueOnly: false,
                }

                return ModalService.openModal({ type: 'contractTerminationModal', size: 'lg' }, modalPayload, () => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))
            }

            $scope.sendSecurityDepositEmail = function () {
                $scope.sendingDeposit = true
                return ApiUser.blockForOverdue({ id_contract: $scope.contract.id }, {}).$promise.then((sendMailResult) => {
                    AlertManager.success('E-mail de demande de dépôt envoyé')
                    const comment = '<b>AUTOMATIQUE</b> : demande de dépôt de garantie envoyée par email'
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    return MetaWatcher.notif('DEPOSIT_CHANGED', $scope.contract) }).catch(ErrorCatcher)
                .finally(() => ($scope.sendingDeposit = false))
            }

            const contractTransitions = BoFeaturesService.getModuleFeatures('contractTransitions')
            const allowedTransitions = {}

            _.each(contractTransitions, (v, k) => {
                if (v) {
                    const [from, to] = k.split('>')
                    allowedTransitions[from] = allowedTransitions[from] || []
                    allowedTransitions[from].push(to)
                }
            })

            $scope.changeStatus = {
                payloads: {
                    status: null,
                },
                fields: {
                    label: {
                        label: (payload) => {
                            const transition = `${$scope.contract.status}>${payload.status}`
                            switch (transition) {
                                case '0>1':
                                    return `
                                        <span class="red">
                                            <span class="fa fa-warning"></span>
                                            Avez-vous bien pensé à créer l'affaire dans SGE ?
                                        </span>`
                                case '1>91':
                                    return `
                                        <span class="red">
                                            <span class="fa fa-warning"></span>
                                            Avez-vous bien pensé à annuler l'affaire dans SGE ?
                                        </span>`
                                default:
                                    return 'Changement de status :'
                            }
                        },
                        type: 'label',
                    },
                    status: {
                        label: 'Status',
                        type: 'select',
                        required: true,
                        placeholder: 'Changement de status',
                        enum: [],
                    },
                    sendMail: {
                        label: (payload) => {
                            switch (`${payload.status}`) {
                                case '1':
                                    return 'Envoyer le mail de confirmation de souscription'
                                case '2':
                                    return `Envoyer le mail de confirmation d'activation`
                                case '91':
                                    return `Envoyer le mail d'annulation`
                                default:
                                    return 'Envoyer le mail'
                            }
                        },
                        hidden: (payload) => {
                            const CAN_SEND_MAIL_CONTRACT_STATUSES = ['1', '2', '91']
                            return !(CAN_SEND_MAIL_CONTRACT_STATUSES.indexOf(`${payload.status}`) > -1)
                        },
                        type: 'checkbox',
                    },
                },
                isEnabled() {
                    return _.keys(allowedTransitions).indexOf(`${$scope.contract.status}`) > -1
                },
                preparePopup() {
                    if (allowedTransitions[$scope.contract.status]) {
                        $scope.changeStatus.payloads = { status: allowedTransitions[$scope.contract.status][0] }
                        $scope.changeStatus.fields.status.enum = _.map(allowedTransitions[$scope.contract.status], (s) => {
                            return {
                                value: s,
                                label: `${$filter('contractStatus')($scope.contract.status)} ➔ ${$filter('contractStatus')(s)}`,
                            }
                        })
                    } else {
                        $scope.changeStatus.payloads = { status: null }
                        $scope.changeStatus.fields.status.enum = []
                    }
                },
                update() {
                    const comment = `
                        <b>AUTOMATIQUE</b> : changement de statut manuel par un admin :
                        <b>${$filter('contractStatus')($scope.contract.status)}</b> ➔ <b>${$filter('contractStatus')($scope.changeStatus.payloads.status)}</b>`
                    return DataAccess.changeContractStatus({
                        id_contract: $scope.contract.id,
                        status: $scope.changeStatus.payloads.status,
                        sendMail: $scope.changeStatus.payloads.sendMail,
                    }, {}).$promise.then(() => {
                        AlertManager.success('Status changé')
                        AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                        MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    }).catch(ErrorCatcher)
                },
            }

            $scope.invoiceV2CheckFields = {
                invoicing_limit: { label: 'Date limite', type: 'date' },
                force: { label: 'Forcer une facture', type: 'checkbox' },
            }

            $scope.invoiceV2CheckPayload = {
                invoicing_limit: moment(),
            }

            $scope.invoiceV2Check = () => {
                ApiBilling.contractCheckReadings({ idContract: $scope.contract.id }, {
                    invoicing_limit: moment($scope.invoiceV2CheckPayload.invoicing_limit).format('YYYY-MM-DD'),
                    force: !!$scope.invoiceV2CheckPayload.force,
                }).$promise.then((reportResult) => {
                    $scope.invoiceV2CheckPayload.invoicing_limit = moment()
                    $scope.invoiceV2CheckPayload.force = false
                    AlertManager.success(reportResult.message)
                })
                .catch(ErrorCatcher)
            }

            const isLocal = window.location.hostname.includes('local.')

            // available only for testing purposes
            $scope.canGetSelfReportURL = $scope.isAIFeatureOn('canGenerateSelfReportURL') && !BoFeaturesService.get('isEnvProd')
            $scope.getSelfReportURL = () => {
                return ApiContent.getToken({ id_contract: $scope.contract.id, id_account: $scope.contract.id_account, type: 'ANON_SELF_REPORT' }).$promise.then((token) => {
                    $window.open(`${EnvUtils.selfcareUrl}${isLocal ? '' : '/auto-releve'}?token=${token.tokenId}`, '_blank')
                })
            }

            $scope.canGetTimetableRegenURL = $scope.isAIFeatureOn('canGenerateTimetableRegenURL') && !BoFeaturesService.get('isEnvProd')
            $scope.getTimetableRegenURL = () => {
                return ApiContent.getToken({
                    id_contract: $scope.contract.id,
                    id_account: $scope.contract.id_account,
                    readingDate: moment().format('YYYY-MM-DD'),
                    origin: 'TEST_BO',
                    type: 'ASK_TIMETABLE_REGEN',
                }).$promise.then((token) => {
                    $window.open(`${EnvUtils.timetableRegenUrl}?token=${token.tokenId}`, '_blank')
                })
            }

            // EXPORT
            $scope.exportPayload = {
                download: true,
                s3: `export_${$scope.contract.id}`,
                dailyConsumption: false,
            }

            $scope.exportFields = {
                download: {
                    label: 'Mode',
                    type: 'radio',
                    enum: [
                        { label: 'Télécharger sur le disque', value: true },
                        { label: 'Rendre disponible sur les autres environnements', value: false },
                    ],
                },
                s3: {
                    hidden: (template) => template.download,
                    label: 'Nom du fichier',
                    type: 'text',
                    required: true,
                },
                dailyConsumption: {
                    label: 'Exporter les données de consommation',
                    type: 'radio',
                    enum: [{
                        label: 'Oui (beaucoup de données)',
                        value: true,
                    }, {
                        label: 'Non',
                        value: false,
                    }],
                },
            }

            $scope.exportContract = () => {
                if (!$scope.exportPayload.download) {
                    $scope.exportingContract = true
                    return ApiAdmin.exportContract({
                        id_contract: $scope.contract.id,
                        s3: $scope.exportPayload.s3,
                        dailyConsumption: $scope.exportPayload.dailyConsumption,
                    }).$promise
                    .then((response) => {
                        AlertManager.success(`Contrat exporté avec succès`)
                    })
                    .catch(ErrorCatcher)
                    .finally(() => {
                        $scope.exportingContract = false
                    })
                }
                $window.open(`/api-admin/export/contract/${$scope.contract.id}?dailyConsumption=${!!$scope.exportPayload.dailyConsumption}`, '_blank')
            }

            $scope.refreshConsumptionAnalysis = (e) => {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                $scope.consumptionAnalysing = true
                return ApiUser.consumptionAnalysis({ id_contract: $scope.contract.id }).$promise
                .then((response) => {
                    $scope.consumptionAnalysis = response
                    if ($scope.consumptionAnalysis.providerCalendarSwitch) {
                        const providerCalendarSwitch = $scope.consumptionAnalysis.providerCalendarSwitch
                        if (providerCalendarSwitch.eligible) {
                            if (providerCalendarSwitch.beneficialSwitch) {
                                providerCalendarSwitch.title = `L'option tarifaire du client n'est pas rentable.`
                                providerCalendarSwitch.icon = 'fa-bell red'
                            } else {
                                providerCalendarSwitch.title = `L'option tarifaire semble adaptée à la consommation du foyer.`
                                providerCalendarSwitch.icon = 'fa-check green'
                            }
                        } else if (providerCalendarSwitch.beneficialSwitch) {
                            providerCalendarSwitch.title = `L'option tarifaire du client ne semble pas rentable. Mais :<br>` +
                                `${providerCalendarSwitch.reasons &&
                                    providerCalendarSwitch.reasons.length &&
                                    providerCalendarSwitch.reasons.join('<br>')}`
                            providerCalendarSwitch.icon = 'fa-times orange'
                        } else if (providerCalendarSwitch.beneficialSwitch === false) {
                            providerCalendarSwitch.title = `L'option tarifaire semble adaptée à la consommation du foyer.`
                            providerCalendarSwitch.icon = 'fa-check green'
                        } else {
                            providerCalendarSwitch.title = (providerCalendarSwitch.reasons &&
                                providerCalendarSwitch.reasons.length &&
                                providerCalendarSwitch.reasons.join('<br>')) ||
                                `L'option tarifaire semble adaptée à la consommation du foyer.`
                            providerCalendarSwitch.icon = 'fa-question enedis-blue'
                        }
                    }
                    return response
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.consumptionAnalysing = false
                })
            }
        },
    })
)
